<template>
    <section class="writings-list">
        <section class="writings-top">
            <AppHeader></AppHeader>
            <el-row class="title-row" type="flex" justify="center" align="middle">
                <el-col :span="24">
                    <h1 class="title-container">
                          مطالب و نوشته‌ها
                    </h1>
                </el-col>
            </el-row>
        </section>
        <el-row v-for="writing in writings" :key="writing._id" class="writing-row">
            <el-col :span="18" :push="3" >
                <article class="writing">
                    <header>
                        <h3>{{writing.title}}</h3>
                        <section class="author">
                            <span>نویسنده: </span>
                            <span>{{writing.creator.firstName}} </span>
                            <span>{{writing.creator.lastName}}</span>
                        </section>
                    </header>
                    <section class="writing-body">
                        <p>{{writing.abstract}}</p>
                        <section>
                            <el-button type="primary" size="small" class="read-more-button"  @click="goToWriting(writing._id)">
                                ادامه مطلب
                                <i class="el-icon-arrow-left"></i>
                            </el-button>
<!--                            <router-link :to="`/writings/${writing._id}`">-->
<!--                                ادامه مطلب-->
<!--                                <i class="el-icon-arrow-left"></i>-->
<!--                            </router-link>-->
                        </section>

                    </section>
                    <footer>
                    <span>
                        نوشته شده در تاریخ:
                        {{dateConverter(writing.createdAt)}}
                    </span>
                    </footer>
                </article>
            </el-col>
        </el-row>
        <AppFooter/>
    </section>
</template>

<script>
    /* eslint-disable */
    import AppHeader from '../AppHeader';
    import AppFooter from '../AppFooter';
    import jMoment from 'jalali-moment';
    export default {
        name: 'WritingsList',
        components: {
            AppFooter,
            AppHeader
        },
        data() {
            return {
                writings: [],
                page: 1,
                limit: 20
            }
        },
        created() {
            this.getWritings(1, 20);
        },
        methods: {
            getWritings(page, limit) {
                this.$http.get(`${this.apiURL}/writing/all?page=${page}&limit=${limit}`).then((response) => {
                    this.writings = response.data.writings;
                    this.page = response.data.page;
                }).catch((error) => {
                    console.error(error.response.data);
                });
            },
            dateConverter(date) {
                let jYear = jMoment(date).format('jYYYY');
                let jMonth = jMoment(date).locale('fa').format('jMMMM');
                let jDay = jMoment(date).locale('fa').format('jDD');
                let jDayOfWeek = jMoment(date).locale('fa').format('dddd');
                return `${jDayOfWeek} ${jDay} ${jMonth} ${jYear}`;
            },
            goToWriting(id) {
                this.$router.push({ name: 'writing-page', params: {id} });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .writings-list {
        background-color: #E8F3EC;

        .writings-top {
            background-image: url('../../assets/images/WritingsPageBanner.jpg');
            background-size: cover;
            background-position: center center;
            height: 45vh;
            margin: 0 0 45px 0;

            .title-container {
                font-size: 45px;
                color: white;
            }
        }

        .writing-row {
            direction: rtl;
            text-align: right;
            margin: 0 0 20px 0;

            .writing {
                padding: 10px 20px;
                background-color: white;
                box-shadow: 0 0 8px 0 rgba(0, 0, 0, .08), 0 0 2px 0 rgba(0, 0, 0, .08);

                header {
                    color: #8b8b8b;
                    margin-bottom: 20px;

                    h3 {
                        margin: 0;
                        color: #4886FF;
                    }
                    .author {
                        font-size: 14px;
                    }
                }

                .writing-body {

                    section {
                        text-align: left;
                        margin: 10px 0;

                        .read-more-button::v-deep {
                            font-weight: bold;

                            i {
                                font-weight: bold;
                            }
                        }
                    }

                }

                footer {
                    padding: 5px;
                    border-top: 1px solid #BBBBBB;
                    font-size: 12px;
                    color: #8b8b8b;
                }
            }
        }
    }
</style>
